import React, {useState} from "react";
import {NavLink, useLocation} from "react-router-dom";
import {JobbizLogo, MenuBar} from "assets/icons";
import Button from "components/button";
import UseContext from "hooks/useContext";

const NavbarAuth = () => {
    const {typeNav} = UseContext();
    const [menu, setMenu] = useState(false);
    const location = useLocation();
    const isLoginPage = location.pathname.startsWith('/login');
    const isRegisterPage = location.pathname.startsWith('/register');

    const closeMenu = () => setMenu(false);

    const switchLink = typeNav === 2 ? '/login/interimaire' : '/login/entreprise';
    const switchLabel = typeNav === 2 ? 'Je suis intérimaire' : 'Je suis une entreprise';
    const connectLink = typeNav === 2 ? '/login/entreprise' : '/login/interimaire';

    const ctaButton = typeNav === 2
        ? { href: 'https://www.jobbiz.fr/demo-entreprise', label: 'Demander une démo', external: true }
        : { to: '/register/interimaire', label: "S'inscrire", external: false };

    return (
        <header className="bg-white shrink-0 relative z-50">
            <nav className="flex items-center justify-between w-full px-8 h-[97px]">
                <div>
                    <JobbizLogo wh={120}/>
                </div>

                <div className="tab:hidden cursor-pointer" onClick={() => setMenu(!menu)}>
                    <MenuBar/>
                </div>

                {/* Desktop */}
                <ul className="hidden tab:flex gap-3 ft-sm font-medium items-center">
                    <li><NavLink className="p-4 font-medium text-[#374151]" to="/help">Aide</NavLink></li>
                    <li><NavLink className="p-4 font-medium text-[#374151]" to={switchLink}>{switchLabel}</NavLink></li>
                    {isRegisterPage ? (
                        <li><NavLink className="p-4 font-medium text-[#374151]" to={connectLink}>Se connecter</NavLink></li>
                    ) : isLoginPage ? (
                        <li>
                            {ctaButton.external
                                ? <a href={ctaButton.href}><Button size={"LG"}>{ctaButton.label}</Button></a>
                                : <NavLink to={ctaButton.to}><Button size={"LG"}>{ctaButton.label}</Button></NavLink>
                            }
                        </li>
                    ) : (
                        <>
                            <li><NavLink className="p-4 font-medium text-[#374151]" to={connectLink}>Se connecter</NavLink></li>
                            <li>
                                {ctaButton.external
                                    ? <a href={ctaButton.href}><Button size={"LG"}>{ctaButton.label}</Button></a>
                                    : <NavLink to={ctaButton.to}><Button size={"LG"}>{ctaButton.label}</Button></NavLink>
                                }
                            </li>
                        </>
                    )}
                </ul>
            </nav>
            <div className="w-full h-px bg-gray-100" aria-hidden="true"/>

            {/* Mobile dropdown */}
            {menu && (
                <>
                    <div className="tab:hidden fixed inset-0 top-[98px] bg-black/20 z-40" onClick={closeMenu}/>
                    <nav className="tab:hidden absolute left-0 right-0 bg-white border-b border-gray-200 shadow-lg z-50">
                        <ul className="flex flex-col ft-sm font-medium">
                            <li className="border-b border-gray-100">
                                <NavLink className="block px-8 py-4 font-medium text-[#374151] active:bg-gray-50" to="/help" onClick={closeMenu}>
                                    Aide
                                </NavLink>
                            </li>
                            <li className="border-b border-gray-100">
                                <NavLink className="block px-8 py-4 font-medium text-[#374151] active:bg-gray-50" to={switchLink} onClick={closeMenu}>
                                    {switchLabel}
                                </NavLink>
                            </li>
                            {isRegisterPage ? (
                                <li className="border-b border-gray-100">
                                    <NavLink className="block px-8 py-4 font-medium text-[#374151] active:bg-gray-50" to={connectLink} onClick={closeMenu}>
                                        Se connecter
                                    </NavLink>
                                </li>
                            ) : isLoginPage ? null : (
                                <li className="border-b border-gray-100">
                                    <NavLink className="block px-8 py-4 font-medium text-[#374151] active:bg-gray-50" to={connectLink} onClick={closeMenu}>
                                        Se connecter
                                    </NavLink>
                                </li>
                            )}
                            {(isLoginPage || (!isRegisterPage && !isLoginPage)) && (
                                <li className="px-8 py-4">
                                    {ctaButton.external ? (
                                        <a href={ctaButton.href} className="block w-full" onClick={closeMenu}>
                                            <Button size={"FULL"}>{ctaButton.label}</Button>
                                        </a>
                                    ) : (
                                        <NavLink to={ctaButton.to} className="block w-full" onClick={closeMenu}>
                                            <Button size={"FULL"}>{ctaButton.label}</Button>
                                        </NavLink>
                                    )}
                                </li>
                            )}
                        </ul>
                    </nav>
                </>
            )}
        </header>
    );
};

export default NavbarAuth;
